import { ProgressBar } from "@commonlibs";
import styled, { css } from "styled-components";
import isEnoughPasswordProgress from "../utils/isPasswordEnoughtStrong";

export const PassswordSecurityProgressBar = styled(ProgressBar)(
    ({ theme, value = 0 }) => css`
        color: ${theme.palette.status[isEnoughPasswordProgress(value) ? "success" : "error"]};
        transition: color 0.2s;
    `,
);
